export default __webpack_public_path__ + "static/media/planetsoft-login-dark-mode.16f7ea59.png";